<template>
    <div class="app-footer">
        <div class="app-footer__inner text-center">
            Copyright {{ new Date().getFullYear()  }} &copy;  <a href="https://nextgn.dev">NextGN</a>
        </div>
    </div>
</template>

<script>
export default {
  name: 'Footer',
}
</script>
